// Header scripts
var headerHeight = $('.site-header-wrapper').innerHeight();
var stickyHeader = $('.site-header-wrapper').clone().addClass('sticky');

var mobileMenu = $('#main-menu-mobile-wrapper');
var mobileMenuOverlay = $('.mobile-menu-overlay');
var mobileMenuWidth = mobileMenu.outerWidth();

var animateMobileMenuOpen = function() {
    mobileMenuOverlay.show();
    mobileMenu.show().addClass('expanded').animate({right:  '0'});
}

var animateMobileMenuClose = function() {
    mobileMenuOverlay.hide();
    mobileMenu.removeClass('expanded').animate({right: '-' + mobileMenuWidth + 'px'});
}

var mobileMenuClose = function() {
    mobileMenuOverlay.hide();
    mobileMenu.removeClass('expanded').css('right', '-' + mobileMenuWidth + 'px');
}

$(document).ready(function() {
    stickyHeader.prependTo('header');
    mobileMenu.prependTo('body').css('right', '-' + mobileMenuWidth + 'px');

    if ($(this).scrollTop() > headerHeight) {
        stickyHeader.addClass('visible');
    }

    $(document).scroll(function() {
        if ($(this).scrollTop() > headerHeight) {
            if (stickyHeader.hasClass('visible') == false) {
                stickyHeader.slideDown('fast').addClass('visible');
            }
        } else {
            stickyHeader.slideUp('fast').removeClass('visible');
        }

        // if (mobileMenu.hasClass('expanded')) {
            // mobileMenuClose();
        //}
    });

    $(window).resize(function() {
        if ($(this).width() > 996) {
            mobileMenuClose();
        }
    });

    $(document).on('click', 'a.mobile-menu-toggle', function (e) {
        e.preventDefault();
        animateMobileMenuOpen();
    });

    $(document).on('click', 'div.menu-close', function () {
        animateMobileMenuClose();
    });

    $(document).on('click', '.mobile-menu-overlay', function () {
        animateMobileMenuClose();
    });
});

$(document).on({
    mouseenter: function() {
        $(this).find('.nav-menu').stop().slideDown('fast').addClass('visible');
    },
    mouseleave: function() {
        $(this).find('.nav-menu').stop().slideUp('fast').removeClass('visible');
    }
}, 'ul#main-menu-desktop li.has-menu');

// Homepage section script
var width = $(window).width();

if (width >= 998) {
    $(document).on({
        mouseenter: function () {
            if ($(this).hasClass('closed')) {
                var other = $('.section-homepage-banner').find('.cta-block.open');
              
                other.removeClass('open').addClass('closed');
                other.find('.cta-contents p, .cta-contents span').stop(true, true).hide();
              
                $(this).removeClass('closed').addClass('open');
                $(this).find('.cta-contents p, .cta-contents span').stop(true, true).hide().delay(100).fadeIn('slow');
            }
        },
    }, '.section-homepage-banner .cta-block');
}

// Accordion script
$(document).on('click', '.accordion-item:not(.empty)', function () {
    $(this).parent('.accordion').find('.accordion-item.open .content').slideUp();

    $(this).toggleClass('open');

    if($(this).hasClass('open')) {
        $(this).find('.content').slideDown();
    } else {
        $(this).find('.content').slideUp();
    }
});

// Script for using links to scroll to section with a page
$(document).ready(function() {
    // Add class 'scroll' to any internal page links
    $("a[href^='#']").addClass("scroll");

    // Remove it if href is only '#'
    $("a[href='#']").removeClass("scroll");

    $(document).on('click', 'a.scroll', function (e) {
        e.preventDefault();
        var sectionID = $(this).attr('href');

       $('html, body').animate({
           scrollTop: $(sectionID).offset().top - 90
       }, 500);
    });
});





